import { CommonModule } from '@angular/common';
import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoadingComponent } from '@scandium-oy/ngx-scandium';
import { combineLatest } from 'rxjs';
import { debounceTime, filter, map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { AppCommonModule } from 'src/app/common.module';
import { DashboardViewComponent } from 'src/app/components/views/dashboard/view-dashboard.component';
import { TimestampPipe } from 'src/app/pipes/timestamp/timestamp.pipe';
import { NavigationService } from 'src/app/services/navigation.service';
import { PlusService } from 'src/app/services/plus.service';
import { SitesService } from 'src/app/services/sites.service';
import { StripeService } from 'src/app/services/stripe.service';
import { UserDirectoryService } from 'src/app/services/user-directory.service';
import { WorkerTicketsService } from 'src/app/services/worker-tickets.service';

@Component({
  selector: 'app-stripe-success-page',
  templateUrl: './success.page.html',
  styleUrls: ['./success.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    CommonModule,
    DashboardViewComponent,
    LoadingComponent,
    TimestampPipe,
  ],
})
export class StripeSuccessPage {
  private plusService = inject(PlusService);
  private route = inject(ActivatedRoute);
  private navigationService = inject(NavigationService);
  private sitesService = inject(SitesService);
  private stripeService = inject(StripeService);
  private usersService = inject(UserDirectoryService);
  private workerTicketsService = inject(WorkerTicketsService);

  priceWithVat = signal<{ price: number; percentage: number }>(null);

  user$ = this.route.queryParams.pipe(
    switchMap((params) => this.usersService.get(params['user'])),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  subscription$ = this.user$.pipe(
    filter((user) => user != null),
    switchMap((user) => this.usersService.getUserSubscriptions(null, { worker: user.guid })),
    map((subs) => subs.length > 0 ? subs[0] : null),
    tap(async (sub) => {
      const item = sub.items[0];
      const taxRate = await this.stripeService.getTaxRate();
      const price = {
        price: (item.price.unit_amount * (taxRate.percentage / 100) + item.price.unit_amount) / 100,
        percentage: taxRate.percentage,
      };
      this.priceWithVat.set(price);
    }),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  params$ = combineLatest([this.route.queryParams, this.sitesService.getActiveList()]).pipe(
    filter(([_, sites]) => sites?.length > 0),
    debounceTime(1000),
    tap(([params, sites]) => {
      if (params['parent'] === 'undefined') {
        // this.navigationService.navigateToHome();
      } else if (params['parent'] !== 'null') {
        this.workerTicketsService.openRoomTicket(params['parent'], params['ticket'], true);
      } else {
        this.plusService.onNewTask(sites, null, null, true);
      }
    }),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  home() {
    this.navigationService.navigateToHome();
  }
}
